"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectTagSummary = void 0;
const base_1 = require("./base");
class IkeObjectTagSummary extends base_1.IkeRestObject {
    constructor() {
        super(...arguments);
        this.className = 'TagSummary';
        this.actionName = 'tag.summary';
    }
}
exports.IkeObjectTagSummary = IkeObjectTagSummary;
//# sourceMappingURL=tag.summary.object.js.map